// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/pages/InstalledProductListPage.js
//
// MODULE: Service CRM
// FEATURE: Installed Products List
// ======================================================================

import React, {
  useState,
  useEffect,
  useCallback,
} from "react";

import { useNavigate } from "react-router-dom";

import installedProductService from "../../services/installedProductService";

import InstalledProductKpiBar from "../components/InstalledProductKpiBar";
import InstalledProductFilterBar from "../components/InstalledProductFilterBar";
import InstalledProductsTable from "../components/InstalledProductsTable";
import InstalledProductsPagination from "../components/InstalledProductsPagination";

export default function InstalledProductListPage() {

  const navigate = useNavigate();

  // -------------------------------------------------------------------
  // STATE
  // -------------------------------------------------------------------
  const [rows, setRows] = useState([]);

  const [pagination, setPagination] = useState({});

  const [page, setPage] = useState(1);

  const [pageSize, setPageSize] = useState(10);

  const [filters, setFilters] = useState({});

  const [loading, setLoading] = useState(false);

  // -------------------------------------------------------------------
  // FILTER CHECK
  // -------------------------------------------------------------------
  const hasFilters =
    Object.keys(filters || {}).length > 0;

  // -------------------------------------------------------------------
  // LOAD DATA
  // -------------------------------------------------------------------
  const load = useCallback(async () => {

    setLoading(true);

    try {

      const res =
        await installedProductService
          .listInstalledProducts({

            page,
            per_page: pageSize,

            ...filters,
          });

      setRows(res.items || []);

      setPagination(res.pagination || {});

    } finally {

      setLoading(false);
    }

  }, [page, pageSize, filters]);

  // -------------------------------------------------------------------
  // INITIAL LOAD
  // -------------------------------------------------------------------
  useEffect(() => {

    load();

  }, [load]);

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div>

      {/* ========================================================= */}
      {/* PAGE HEADER */}
      {/* ========================================================= */}

      <div
        style={{
          background:
            "linear-gradient(90deg, #0d6efd, #3d8bfd)",

          borderRadius: 14,

          padding: "16px 22px",

          color: "#fff",

          display: "flex",

          justifyContent: "space-between",

          alignItems: "center",

          marginBottom: 20,
        }}
      >

        {/* LEFT */}
        <div>

          <div
            style={{
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            Installed Products
          </div>

          <div
            style={{
              fontSize: 13,
              opacity: 0.9,
            }}
          >
            Manage customer installed machines
            and commissioning lifecycle
          </div>

        </div>

        {/* RIGHT */}
        <button
          onClick={() =>
            navigate(
              "/service-crm/installed-products/create"
            )
          }

          style={{
            background: "#fff",

            color: "#0d6efd",

            border: "none",

            borderRadius: 8,

            padding: "8px 14px",

            fontWeight: 600,

            cursor: "pointer",
          }}
        >
          + Add Product
        </button>

      </div>

      {/* ========================================================= */}
      {/* KPI BAR */}
      {/* ========================================================= */}

      <InstalledProductKpiBar
        rows={rows}
      />

      {/* ========================================================= */}
      {/* FILTER BAR */}
      {/* ========================================================= */}

      <InstalledProductFilterBar
        filters={filters}

        onApply={(f) => {

          setPage(1);

          setFilters(f);
        }}
      />

      {/* ========================================================= */}
      {/* TABLE */}
      {/* ========================================================= */}

      <InstalledProductsTable
        rows={rows}

        loading={loading}

        hasFilters={hasFilters}
      />

      {/* ========================================================= */}
      {/* PAGINATION */}
      {/* ========================================================= */}

      <InstalledProductsPagination
        page={page}

        pageSize={pageSize}

        total={pagination.total || 0}

        onPageChange={setPage}

        onPageSizeChange={(size) => {

          setPage(1);

          setPageSize(size);
        }}
      />

    </div>
  );
}